export default __webpack_public_path__ + "static/media/take_photo.ac3b442a.svg";